// Display order for payment methods in purchase order forms.
// Unknown methods go last, keeping the order the API returned.
const ORDER = [
  "19020ee6-6acc-4ef8-b64a-b177dadc272a", // Crédito
  "3fbc4f1c-8f2e-49ab-ba17-c4bcf2da7982", // Transferencia
  "21f7a6a7-db5f-4d52-8472-3c3b8d613f27", // Compra anticipada
  "27a133a3-0a27-4910-af11-9750cd21cfc6", // Efectivo
  "17cfa181-df73-478b-9c27-ecdd01730bc5", // Otro
];

export function sortPaymentMethods(list, idKey = "sPaymentMethodId") {
  const rank = (m) => {
    const i = ORDER.indexOf(m[idKey]);
    return i === -1 ? ORDER.length : i;
  };
  return [...list].sort((a, b) => rank(a) - rank(b));
}
